<svc-dialog #dialog [hasActions]="false">
  <mat-icon
    svc-dialog-title-icon
    class="svc-alert-dialog__icon"
    svgIcon="heroicons_solid:exclamation-triangle"
  ></mat-icon>

  <div svc-dialog-title class="svc-alert-dialog__title flex items-center gap-2">
    <span>{{ title | transloco }}</span>
  </div>

  <div svc-dialog-content class="m-4">
    <p class="text-sm px-2">
      {{ text | transloco }}
    </p>

    <div mat-dialog-actions class="flex justify-end p-2 mt-5">
      <div class="flex gap-2">
        <button
          svc-filled-btn
          id="svc-alert-dialog-button-confirm"
          type="button"
          class="svc-alert-dialog__button"
          (click)="closeDialog()"
        >
          {{ buttonText | transloco }}
        </button>
      </div>
    </div>
  </div>
</svc-dialog>
